import type { MediaSourceData } from '../asset/MediaAsset';

export enum TemplateColorProperties {
    COLOR = 'color',
    ALPHA = 'alpha',
}

export type TemplateColor = {
    /** A number from 0 to 0xFFFFFF, representing RGB color in hex notation */
    [TemplateColorProperties.COLOR]: number;
    /** Alpha value from 0 to 1 */
    [TemplateColorProperties.ALPHA]: number;
    /** Indicates if the user should be able to edit the alpha value */
    alphaEditable: boolean;
};

export enum TemplateWatermarkProperties {
    SOURCE_DATA = 'sourceData',
}

export type TemplateWatermarkSource = {
    [TemplateWatermarkProperties.SOURCE_DATA]: MediaSourceData;
};
